const state = {
    username: '',
    email: '',
    password:'',
    userType:''
}

const getters = {

}

const mutations = {

}

const actions = {

}

export const users = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}